import { Box, BoxProps, Button, ButtonProps, Skeleton, styled, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TodoListItemProps } from './todo-list-item.types';

export const TodoListItem = (item: TodoListItemProps) => {
  const navigate = useNavigate();
  const isLoading = !item.title || !item.subtitle || !item.buttonText;

  const handleNavigation = () => {
    if (item) {
      navigate(item.navigationUrl);
    }
  };
  return (
    <StylesListItemBox>
      <Box>
        <Typography variant="h2" noWrap>
          {isLoading ? <Skeleton height={20} width={250} /> : item.title}
        </Typography>
        <Typography variant="subtitle1" noWrap>
          {isLoading ? <Skeleton height={20} width={200} /> : item.subtitle}
        </Typography>
      </Box>
      <Box>
        <StyledButton onClick={handleNavigation}>
          {isLoading ? <Skeleton height={20} width={100} /> : item.buttonText}
        </StyledButton>
      </Box>
    </StylesListItemBox>
  );
};

const StylesListItemBox = styled(Box)<BoxProps>(({ theme }) => ({
  borderRadius: '16px',
  background: theme.palette.lwWhite[100],
  padding: `${theme.spacing(4)} ${theme.spacing(5)}`,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: '0px 12px 16px 0px rgba(51, 51, 51, 0.02)',
}));

const StyledButton = styled(Button)<ButtonProps>(({ theme }) => ({
  borderRadius: '24px',
  border: `1px solid ${theme.palette.lwSecondary[100]}`,
  color: theme.palette.lwSecondary[100],
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: 500,
  height: 'fit-content',
  padding: `${theme.spacing(2)} ${theme.spacing(6)}`,
  gap: theme.spacing(2),
}));
